module.exports = "<trip-details\n              [tripDetails]=\"tripDetails\"\n              [form]=\"tripDetailsForm\"\n              [policyConfig]=\"policyConfig\"\n              [states]=\"states\"\n              [submitted]=\"submitted\"\n              [baseUrl]=\"blockedProvidersBaseUrl\"\n              [overrideValidation]=\"true\"></trip-details>";


//////////////////
// WEBPACK FOOTER
// ./src/typescript/policy-edit/trip-details/edit-trip-details.component.html
// module id = 1101
// module chunks = 1